export enum SaveErrorToast {
  ALWAYS = 'always',
  ACTIONABLE_ONLY = 'actionable-only',
  NONE = 'none',
}
